<template>
  <div v-if="src" class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="close"><span class="blind">close</span></button>
      <video :src="src" controls class="videoPlayer"></video>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'lang',
    'src'
  ],
  created () {
    window.addEventListener('popstate', this.winPopstate)
  },
  data () {
    return {
    }
  },
  methods: {
    winPopstate (e) {
      this.close()
    },
    close () {
      this.$store.commit('setVideoSrc', null)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 75px;
  background-color: rgba(0,0,0,0.9);
  z-index: 999999999;
  .inner {
    max-width: none;
    padding: 0;
    background: none;
  }
  .videoPlayer {
    display: block;
    max-width: calc(100% - 2px);
    margin: 0 auto;
    border: 1px solid rgba(255,255,255,0.2);
  }
}
</style>
